import { Typography } from 'antd'
import cx from 'classnames'
import _ from 'lodash'
import { pullLeft, pullRight } from '../../../../../../styles/shared.css'
import { dollarFormat, numeralFormat } from '../../../../../../../lib/renderUtil'
import { HyperLink } from '../../../../../Common/Form'
import PieTable from '../../../../../Common/NewDashboard/Table/PieTable/PieTable'
import PieTableStyles from '../../../../../Common/NewDashboard/Table/PieTable/PieTable.css'
import Sort from '../../../../../Common/NewDashboard/Sort/Sort'
import { COLORS } from '../ReturnSummaries'

const { Text } = Typography

export const FIELD = {
  REASON: 'reason',
  AMOUNT: 'amount',
  QUANTITY: 'quantity',
  LISTING_COUNT: 'listingCount'
}

export const FIELD_MAP = {
  [FIELD.REASON]: '關鍵字',
  [FIELD.AMOUNT]: '退貨金額',
  [FIELD.QUANTITY]: '退貨數量',
  [FIELD.LISTING_COUNT]: '賣場數'
}

const getOrderedColumns = () => [
  {
    id: FIELD.REASON,
    accessor: FIELD.REASON,
    // width: 200,
    headerClassName: cx(pullLeft, PieTableStyles.col, PieTableStyles.start),
    className: cx(pullLeft, PieTableStyles.col, PieTableStyles.start),
    Header: FIELD_MAP[FIELD.REASON],
    Cell: row => {
      return (
        <>
          <span
            style={{
              backgroundColor: COLORS[row.index % COLORS.length],
              display: 'inline-block',
              width: '16px',
              height: '16px',
              verticalAlign: 'middle',
              marginRight: '12px'
            }}
          />
          <Text ellipsis>{row.value}</Text>
        </>
      )
    }
  },
  {
    id: FIELD.AMOUNT,
    accessor: FIELD.AMOUNT,
    width: 100,
    Header: FIELD_MAP[FIELD.AMOUNT],
    headerClassName: cx(pullRight, PieTableStyles.col),
    className: cx(pullRight, PieTableStyles.col),
    Cell: row => dollarFormat(_.toNumber(row.value))
  },
  {
    id: FIELD.QUANTITY,
    accessor: FIELD.QUANTITY,
    width: 100,
    Header: FIELD_MAP[FIELD.QUANTITY],
    headerClassName: cx(pullRight, PieTableStyles.col, PieTableStyles.end),
    className: cx(pullRight, PieTableStyles.col, PieTableStyles.end),
    Cell: row => numeralFormat(row.value, { allowZero: true })
  }
]

const [reasonColumn, amountColumn, quantityColumn] = getOrderedColumns()
const getDefaultColumns = props => [
  reasonColumn,
  {
    ...amountColumn,
    width: 70
  },
  {
    ...quantityColumn,
    width: 70,
    headerClassName: cx(pullRight, PieTableStyles.col),
    className: cx(pullRight, PieTableStyles.col)
  },
  {
    id: FIELD.LISTING_COUNT,
    accessor: FIELD.LISTING_COUNT,
    width: 70,
    Header: FIELD_MAP[FIELD.LISTING_COUNT],
    headerClassName: cx(pullRight, PieTableStyles.col, PieTableStyles.end, PieTableStyles.lastCol),
    className: cx(pullRight, PieTableStyles.col, PieTableStyles.end, PieTableStyles.lastCol),
    Cell: row => {
      const {
        id,
        reason
      } = _.get(row, 'original', {})
      return (
        <HyperLink
          data-role='bestseller-available-count'
          onClick={() => props.onListingCountClick(id, reason)}
        >
          {numeralFormat(row.value, { allowZero: true })}
        </HyperLink>
      )
    }
  }
]

const orderedSortOptions = [
  {
    value: FIELD.AMOUNT,
    text: FIELD_MAP[FIELD.AMOUNT]
  },
  {
    value: FIELD.QUANTITY,
    text: FIELD_MAP[FIELD.QUANTITY]
  }
]

const defaultSortOptions = [
  ...orderedSortOptions,
  {
    value: FIELD.LISTING_COUNT,
    text: FIELD_MAP[FIELD.LISTING_COUNT]
  }
]

const SummariesTable = props => {
  const {
    data,
    isOrderSearch,
    onSortChange,
    sortType
  } = props
  // 排序與顯示欄位會根據是否為指定賣場查詢而有不同
  let currentSortOption = defaultSortOptions
  let currentColumns = getDefaultColumns(props)
  if (isOrderSearch) {
    currentSortOption = orderedSortOptions
    currentColumns = getOrderedColumns()
  }
  return (
    <>
      <Sort
        id='return-analysis'
        options={currentSortOption}
        onChange={onSortChange}
        sortType={sortType}
      />
      <PieTable
        data={data}
        columns={currentColumns}
      />
    </>
  )
}

export default SummariesTable
